import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Problem } from '../models/problem.model';

export const OFFLINE = Symbol('offline');

export function handleHttpError(error: HttpErrorResponse): Observable<any> {
  if (error.status === 0 && error.error instanceof ProgressEvent) {
    // Problème de connexion (hors-ligne ou fortement dégradé)
    return throwError(() => OFFLINE);
  }
  // return an observable with a user-facing error message
  return throwError(() => error);
}

export function getProblemFromHttpError(httpError): Problem {
  return httpError?.error;
}
